import type { AnalysisResult, WasmAnalyzer } from "../types.js";

export async function loadAnalyzer() {
  const imports = {};
  const { instance } = await WebAssembly.instantiateStreaming(
    fetch("./cowdiff.wasm"),
    imports,
  );
  return instance.exports as unknown as WasmAnalyzer;
}

export function analyzeDiff(wasm: WasmAnalyzer | null, diff: string): AnalysisResult {
  if (!wasm) {
    throw new Error("The Rust analyzer is still loading. Try again in a moment.");
  }
  const bytes = new TextEncoder().encode(diff);
  const inputPointer = wasm.alloc(bytes.length);
  new Uint8Array(wasm.memory.buffer, inputPointer, bytes.length).set(bytes);
  const resultPointer = wasm.analyze_diff(inputPointer, bytes.length);
  wasm.dealloc(inputPointer, bytes.length);
  const resultLength = new DataView(wasm.memory.buffer).getUint32(
    resultPointer,
    true,
  );
  const resultBytes = new Uint8Array(
    wasm.memory.buffer,
    resultPointer + 4,
    resultLength,
  );
  const json = new TextDecoder().decode(resultBytes);
  wasm.free_result(resultPointer);
  return JSON.parse(json) as AnalysisResult;
}

export function allowProgressPaint(): Promise<void> {
  return new Promise<void>((resolve) => {
    let settled = false;
    const finish = () => {
      if (settled) return;
      settled = true;
      resolve();
    };
    window.setTimeout(finish, 80);
    requestAnimationFrame(() => requestAnimationFrame(finish));
  });
}
